import { Component, inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { atLeastTwoWordsValidator } from '../../data-access/utils/common.utils';
import { UserActions } from '../../data-access/state/user-account-settings.actions';
import { EnableEscCloseDirective, UiButtonComponent } from '@ui';
import { Store } from '@ngrx/store';
import { UserAccountSettingsState } from '../../data-access/state/user-account-settings.reducer';
import { UserModels } from '@share-models';

@Component({
  selector: 'app-change-user-name-modal',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogClose,
    TranslatePipe,
    UiButtonComponent,
  ],
  templateUrl: './change-user-name-modal.component.html',
  styleUrl: './change-user-name-modal.component.scss',
  hostDirectives: [EnableEscCloseDirective],
})
export class ChangeUserNameModalComponent implements OnInit {
  public userNameFormControl = new FormControl<string>('', [
    Validators.required.bind(Validators),
    atLeastTwoWordsValidator,
  ]);

  private dialogRef = inject(MatDialogRef<ChangeUserNameModalComponent>);
  private store$ = inject<Store<UserAccountSettingsState>>(Store);
  public data = inject<{ user: UserModels.UserDocument }>(MAT_DIALOG_DATA);

  public ngOnInit(): void {
    const user = this.data?.user ?? null;
    if (user) {
      const fullUserName = `${user.firstname ?? ''} ${user.lastname ?? ''}`;
      this.userNameFormControl.patchValue(fullUserName);
    }
  }

  public close(): void {
    this.dialogRef.close();
  }

  public save(): void {
    const formValue = this.userNameFormControl.value?.trim();
    if (!formValue) {
      return;
    }

    const splitValue = formValue.split(' ');
    const firstname = splitValue?.[0];
    splitValue.splice(0, 1);
    const lastname = splitValue.join(' ').trim();
    const payload: Record<string, unknown> = { firstname };
    if (lastname) {
      payload['lastname'] = lastname;
    }

    this.store$.dispatch(
      UserActions.startUpdateUserProfile({
        data: payload,
      }),
    );
    this.dialogRef.close();
  }
}
